<template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full" no-footer-line>
                <h4 slot="header" class="card-title">Manage Notifications</h4>
                <div>
                    <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div>
                            
                            <el-select
                                class="select-primary mb-3"
                                style="width: 200px"
                                v-model="pagination.perPage"
                                v-if="pagination"
                                placeholder="Per page"
                            >
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions"
                                :key="item"
                                :label="item"
                                :value="item"
                                ></el-option>
                            </el-select>

                            <n-button
                                @click.native="openModal()"
                                class="view ml-2"
                                type="primary"
                                size="sm"
                                round
                                icon
                                simple
                            >
                                <i class="fa fa-plus"></i>
                            </n-button>

                        </div>
                        
                        <fg-input>
                            <el-input type="search"  class="mb-3" style="width: 400px"
                            prefix-icon="el-icon-search"
                            :placeholder="`Search by ${propsToSearch.join(', ').trim(', ').replace('.',' ')}`"
                            v-model="searchQuery"
                            aria-controls="datatables"
                            ></el-input>
                        </fg-input>
                    </div>
                    <el-table stripe style="width: 100%;" :data="queriedData" size="mini">
                        <el-table-column
                            v-for="(column, index) in tableColumns"
                            :key="index"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label"
                            :sortable="column.sortable || false"
                            :align="column.align"
                            :header-align="column.align"
                            v-if="!column.hidden"
                            :fixed="column.fixed || false"
                            :formatter="column.formatter || null"
                        ></el-table-column>
                        
                        <el-table-column :min-width="135" fixed="right" label="Actions" align="right">
                            <div slot-scope="props" class="table-actions">
                                <n-button
                                    @click.native="handleView(props.$index, props.row)"
                                    class="view"
                                    type="primary"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-eye"></i>
                                </n-button>
                                <n-button
                                    @click.native="handleEdit(props.$index, props.row)"
                                    class="edit"
                                    type="warning"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-pencil"></i>
                                </n-button>
                                <n-button
                                    @click.native="handleDelete(props.$index, props.row)"
                                    class="remove"
                                    type="danger"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-times"></i>
                                </n-button>
                            </div>
                        </el-table-column>
                    </el-table>
                </div>
                <div
                    slot="footer"
                    class="d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                    <div class>
                    <p class="card-category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
                    </div>
                    <n-pagination
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                    ></n-pagination>
                </div>
            </card>
        </div>

        <modal :show.sync="modals.add" headerClasses="justify-content-center" footerClasses="justify-content-sm-between">
            <h4 slot="header" class="title title-up">Add New Notification</h4>
            <form>
                <div class="row">
                    <div class="col-12">
                        <fg-input
                            type="text"
                            required
                            name="title"
                            label="Notifications Title"
                            v-validate="modelValidations.title"
                            :error="getError('title')"
                            v-model="model.title">
                        </fg-input>
                    </div>
                    <div class="col-12">
                        <fg-input
                            type="text"
                            required
                            name="body"
                            label="Notifications Body"
                            v-validate="modelValidations.body"
                            :error="getError('body')"
                            v-model="model.body">
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="text"
                            required
                            name="topics"
                            label="Topics"
                            v-validate="modelValidations.topics"
                            :error="getError('topics')"
                            v-model="model.topics">
                            <el-select class="select-primary" placeholder="Select Topics" v-model="model.topics" value-key="register_no" clearable filterable multiple>
                                <el-option v-for="(option, index) in topics" class="select-primary" :value="option" :label="`${option}`" :key="index">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="date"
                            name="time"
                            label="Time"
                            v-validate="modelValidations.time"
                            :error="getError('time')"
                            v-model="model.time">
                            <el-date-picker 
                                v-model="model.time" 
                                type="datetime" 
                                placeholder="time">
                            </el-date-picker>
                        </fg-input>
                    </div>
                </div>
            </form>
            <template slot="footer">
                <n-button @click.native.prevent="validate('send')" type="success">Send Notification</n-button>
                <n-button @click.native.prevent="validate('save')" type="primary">Save Notification</n-button>
            </template>
        </modal>

    </div>
</template>

<script>
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import { Pagination as NPagination, Modal, Switch } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";

import { mapGetters } from 'vuex';

export default {
    components: {
        NPagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [DatePicker.name]: DatePicker,
        Modal,
        [Switch.name]: Switch
    },
    computed: {
        ...mapGetters({
            tableData: 'getNotifications',
            topics: 'getTopics',
            preferences: 'getPreferences',
            authTokens: 'getAuthTokens',
        }),

        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.searchedData;
            // if (this.searchedData.length > 0) {
            //     result = this.searchedData;
            // }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length;
        }
    },
    data() {
        return {
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
            searchQuery: "",
            propsToSearch: [ "title", "body" ],
            tableColumns: [
                {
                    prop: "_id",
                    label: "ID",
                    hidden: true,
                    minWidth: 200,
                },
                {
                    prop: "title",
                    label: "Title",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "body",
                    label: "Body",
                    minWidth: 250,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "topics",
                    label: "Topics",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return cellValue.join(', ').trim(', ')
                    }
                },
                {
                    prop: "sent",
                    label: "Sent?",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return cellValue ? 'Yes' : 'No'
                    }
                },
                {
                    prop: "time",
                    label: "Time",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        let d = new Date(cellValue)
                        return d.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' })
                    }
                },
            ],
            searchedData: [],
            fuseSearch: null,
            modals: {
                add: false
            },
            model: {
                title: '',
                time: new Date(),
                body: '',
                topics: [],
                input: '',
            },
            modelValidations: {
                title: {
                    required: true,
                },
                body: {
                    required: true,
                },
                time: {
                    required: true,
                },
                topics: {
                    required: true,
                },
            },
            filterMethod(query, item) {
                return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
            }
        };
    },
    methods: {
        handleView(index, row) {
            // handleView
        },
        handleEdit(index, row) {
            this.model.title = row.title
            this.model.body = row.body
            this.model.time = row.time
            this.model.topics = row.topics
            this.model._id = row._id
           
            this.scope = 'edit'
            this.modals.add = true
        },
        handleDelete(index, row) {
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-default btn-fill",
                confirmButtonText: "Delete it!",
                buttonsStyling: false
            }).
            then(result => {
                if (result.value) {
                    this.deleteRow(row);
                }
            });
        },
        deleteRow(row) {
            this.$store.dispatch('deleteNotification', row._id)
        },
        openModal(){
            
            this.errors.clear();
            this.$nextTick(() => {
                this.$validator.reset();
            });

            this.model.title = ''
            this.model.body = ''
            this.model.time = new Date()
            this.model.topics = []

            this.scope = 'add'
            this.modals.add = true
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validate(action) {
            this.$validator.validateAll().then(isValid => {
                // this.$emit('on-submit', this.registerForm, isValid);
                if(isValid){

                    switch(action){
                        case 'send':
                            this.$store.dispatch('sendNotification', this.model);
                            break;
                        case 'save':
                            switch(this.scope){
                                case 'add'  : this.$store.dispatch('createNotification', this.model); break;
                                case 'edit' : this.$store.dispatch('updateNotification', this.model); break;
                            }
                            break;
                    }
                    this.modals.add = false
                }
            });
        },
    },
    mounted() {
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: this.propsToSearch,
            threshold: 0.1
        });

        this.$nextTick(() => {
            this.pagination.perPage = this.preferences.perPage
        })

        this.$store.dispatch('getNotifications');
        this.$store.dispatch('getTopics');
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery: {
            handler: function(value){
                let result = Object.assign([], this.tableData);
                if (value !== "") {
                    result = this.fuseSearch.search(value);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        tableData: {
            handler: function(value){
                this.fuseSearch = new Fuse(value, {
                    keys: this.propsToSearch,
                    threshold: 0.1
                })
                let result = Object.assign([], value);
                if (this.searchQuery !== "") {
                    result = this.fuseSearch.search(this.searchQuery);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        'pagination.perPage'(value){
            this.preferences.perPage = value
            this.$store.commit('setPreferences', this.preferences)
        }
    }
};
</script>
<style lang="scss">
    .has-success.has-label:after, 
    .has-danger.has-label:after {
        top: 43px;
    }

    .el-transfer-panel__filter.el-input{
        width: 85%;
    }

    .bootstrap-switch{
    display: block;
    width: 90px!important;
    height: 35px!important;

    &.bootstrap-switch-on{
        .bootstrap-switch-label{
            left: 70%;
        }
    }

    .bootstrap-switch-label{
        width: 35px!important;
        height: 35px!important;
    }

    .bootstrap-switch-handle-off,
    .bootstrap-switch-handle-on{
        font-weight: bold;
        line-height: 22px;
        text-indent: 10px;
        color: #273c75!important;
        width: 100%!important;
    }
    .bootstrap-switch-handle-off{
        text-indent: 15px;
    }
}
</style>

